import Vue from 'vue';

Vue.mixin({
  methods: {
    getValidationClass(formName: string, fieldName: string): any {
      if (!this.$v || !this.$v[formName]) {
        return false;
      }
      let field: any = this.$v[formName];
      const keys = fieldName.split('.');
      keys.forEach(key => {
        field = field[key];
      });
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty && !field.$pending,
        };
      }
    },
    forceValidation(formName: string, fieldName: string): void {
      if (!this.$v || !this.$v[formName]) {
        return;
      }
      let field: any = this.$v[formName];
      const keys = fieldName.split('.');
      keys.forEach(key => {
        field = field[key];
      });
      if (field) {
        field.$touch();
      }
    },
    validateBeforeSubmit(formName: string): boolean {
      if (!this.$v || !this.$v[formName]) {
        return false;
      }
      const form = this.$v[formName];
      form.$touch();
      return !(form.$pending || form.$error);
    },
  },
});
